import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              编辑推荐的同人动画创作精华内容
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-2 text-accent-500">
            <i className="ri-sparkling-line"></i>
            <span className="text-sm font-medium">编辑精选</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}